import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import laravelImg from "../../../components/img/laravel.webp";
import reactImg from "../../../components/img/react.webp";
import phpImg from "../../../components/img/php.webp";
import jQueryImg from "../../../components/img/jquery.webp";
import bootstrapImg from "../../../components/img/bootstrap.webp";
import mySQLImg from "../../../components/img/mysql.webp";
import gitImg from "../../../components/img/git.webp";
import htmlImg from "../../../components/img/html.webp";
import cssImg from "../../../components/img/css.webp";
import sshImg from "../../../components/img/ssh.webp";
import sassImg from "../../../components/img/sass.webp";

function SlideHomeStacks() {
  const settings = {
    loop: true,
    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
    },
    slidesPerView: 4,
    spaceBetween: 60,
    breakpoints: {
      1200: {
        slidesPerView: 9,
      },
      998: {
        spaceBetween: 30,
        slidesPerView: 7,
      },
      762: {
        spaceBetween: 30,
        slidesPerView: 7,
      },
      0: {
        spaceBetween: 20,
        slidesPerView: 5,
      },
    },
  };

  const images = [
    { src: laravelImg, alt: "Laravel Pandin" },
    {
      src: reactImg,
      alt: "React Pandin",
    },
    {
      src: jQueryImg,
      alt: "jQuery Pandin",
    },
    {
      src: phpImg,
      alt: "PHP Pandin",
    },
    {
      src: bootstrapImg,
      alt: "Bootstrap Pandin",
    },
    {
      src: mySQLImg,
      alt: "MySQL Pandin",
    },
    {
      src: gitImg,
      alt: "Git Pandin",
    },
    {
      src: sshImg,
      alt: "SSH Pandin",
    },
    {
      src: htmlImg,
      alt: "HTML Pandin",
    },
    {
      src: cssImg,
      alt: "CSS Pandin",
    },
    {
      src: sassImg,
      alt: "SASS Pandin",
    },
  ];

  const items = images.map((image, index) => (
    <SwiperSlide key={index}>
      <img className="w-100" src={image.src} alt={image.alt} />
    </SwiperSlide>
  ));

  return (
    <Swiper modules={[Autoplay]} {...settings}>
      {items}
    </Swiper>
  );
}

export default SlideHomeStacks;
